import { createFileRoute } from '@tanstack/react-router';

import { EvidenceInboxView } from '../../features/inbox/evidence-inbox-view';

export const Route = createFileRoute('/inbox/')({
  staticData: {
    section: 'Quality',
    breadcrumb: 'Inbox',
    layout: 'full-height',
    // `?selected=` names a specific job card, so it cannot survive a partner
    // switch — see the flag's docs in router-types.d.ts.
    resetSearchOnPartnerChange: true,
  },
  component: EvidenceInboxView,
});
